import Remote from '../remote';
import Modal from '../modals2';
import flash from '../flash';
import Vue from 'vue';
import './curriculum/components';

export default class CurriculumViewer {
  constructor(opts) {
    this.options = opts;
    this.remote = new Remote('/learn/documents');
  }

  display(el, opts) {
    let url_prefix = opts.type ? opts.type + '/' : '';
    this.remote.get(`${url_prefix}${opts.id}/tags`).then((res) => {
      let vue = new Vue({
        el: el,
        template: `<div class="lp--curriculumEditor" tabindex="-1">
        <section class="lp--curriculumHeader">
        </section>
        <curriculum-menu :documents="documents" :shouldDisplayOverview="hasTags" :selectedDocument="currentDocument" :editMode="editMode" v-on:navigate="navigate"></curriculum-menu>        
        <curriculum-document ref="documentViewer" v-if="currentDocument" :currentDocument="currentDocument" :editMode="editMode"></curriculum-document>        
        <curriculum-overview v-if="shouldDisplayOverview && hasTags"  :documents="documents" :editMode="editMode" v-on:toggleContext="toggleContextMode"></curriculum-overview>
        <curriculum-viewer-placeholder :type="type" v-if="shouldDisplayOverview && !hasTags"></curriculum-viewer-placeholder>
        </div>`,
        methods: {
          toggleContextMode: function (document_uuid) {
            this.navigate(document_uuid);
            setTimeout(() => {
              this.$refs.documentViewer.contextMode = true;
            }, 20);
          },
          navigate: function (document_uuid) {
            if (document_uuid) {
              for (let i = 0; i < this.documents.length; i++) {
                if (document_uuid == this.documents[i].uuid) {
                  this.currentDocument = this.documents[i];
                }
              }
              return true;
            } else {
              this.currentDocument = null;
              return true;
            }
          },
          closeModal: function () {
            _t.modal.hide();
          },
        },
        computed: {
          curriculumViewerTitle: function () {
            return i18n.__('curriculum_viewer_title');
          },
          shouldDisplayOverview: function () {
            this.currentDocument;
            return !this.currentDocument;
          },
          hasTags: function () {
            for (var i = 0; i < this.documents.length; i++) {
              for (var j = 0; j < this.documents[i].abilities.length; j++) {
                if (this.documents[i].abilities[j].checked) {
                  return true;
                }
              }
              for (var j = 0; j < this.documents[i].content.length; j++) {
                for (var k = 0; k < this.documents[i].content[j].items.length; k++) {
                  if (this.documents[i].content[j].items[k].checked) {
                    return true;
                  }
                }
              }
            }
            return false;
          },
        },
        data: function () {
          return {
            documents: res.documents,
            currentDocument: res.documents[0],
            editMode: false,
            type: opts.type,
          };
        },
      });
    });
  }

  load(url_prefix) {
    return this.remote.get(`${url_prefix}${this.options.getId()}/tags`);
  }

  view() {
    let url_prefix = this.options.getType() ? this.options.getType() + '/' : '';
    this.load(url_prefix)
      .then((res) => {
        this.modal = new Modal($(Handlebars.templates['curriculum/editor'](res)), {
          modal_id: 'content-modal',
          name: 'Alexandria',
          nonStackable: true,
          class: 'alexandria',
        });

        let _t = this;
        this.modal.eventSource.on('added.panel', (ev) => {
          let vue = new Vue({
            el: '.lp--curriculumEditorContainer',
            template: `<div class="lp--curriculumEditor" tabindex="-1">
          <section class="lp--curriculumHeader">
            <a href="#" class="lp--curriculumModal-close" v-on:click.prevent="closeModal" :title="i18n('app_close')"></a>
            <h2 class="lp--curriculumItemTitle">{{curriculumViewerTitle}}</h2>
          </section>
          <curriculum-menu :documents="documents" :shouldDisplayOverview="hasTags" :selectedDocument="currentDocument" :editMode="editMode" v-on:navigate="navigate"></curriculum-menu>        
          <curriculum-document ref="documentViewer" v-if="currentDocument" :currentDocument="currentDocument" :editMode="editMode"></curriculum-document>        
          <curriculum-overview v-if="shouldDisplayOverview && hasTags"  :documents="documents" :editMode="editMode" v-on:toggleContext="toggleContextMode"></curriculum-overview>
          <curriculum-viewer-placeholder :type="type" v-if="shouldDisplayOverview && !hasTags"></curriculum-viewer-placeholder>
          </div>`,
            methods: {
              i18n: function (str) {
                return i18n.__(str);
              },
              toggleContextMode: function (document_uuid) {
                this.navigate(document_uuid);
                setTimeout(() => {
                  this.$refs.documentViewer.contextMode = true;
                }, 20);
              },
              navigate: function (document_uuid) {
                if (document_uuid) {
                  for (let i = 0; i < this.documents.length; i++) {
                    if (document_uuid == this.documents[i].uuid) {
                      this.currentDocument = this.documents[i];
                    }
                  }
                  return true;
                } else {
                  this.currentDocument = null;
                  return true;
                }
              },
              closeModal: function () {
                _t.modal.hide();
              },
            },
            computed: {
              curriculumViewerTitle: function () {
                return i18n.__('curriculum_viewer_title');
              },
              shouldDisplayOverview: function () {
                this.currentDocument;
                return !this.currentDocument;
              },
              hasTags: function () {
                for (var i = 0; i < this.documents.length; i++) {
                  for (var j = 0; j < this.documents[i].abilities.length; j++) {
                    if (this.documents[i].abilities[j].checked) {
                      return true;
                    }
                  }
                  for (var j = 0; j < this.documents[i].content.length; j++) {
                    for (var k = 0; k < this.documents[i].content[j].items.length; k++) {
                      if (this.documents[i].content[j].items[k].checked) {
                        return true;
                      }
                    }
                  }
                }
                return false;
              },
            },
            data: function () {
              return {
                documents: res.documents,
                currentDocument: res.documents[0],
                editMode: false,
                type: _t.options.getType(),
              };
            },
          });
        });

        this.modal.show();
      })
      .catch(function (err) {
        console.error(err);
        flash(i18n.__('error_curriculum_load_failed'));
      });
  }
}

export class StaticCurriculumViewer extends CurriculumViewer {
  load(url_prefix) {
    let data = JSON.parse(document.getElementById('static-data-documents').innerHTML);
    return Promise.resolve({ documents: data });
  }
}
